<template>
  <div></div>
</template>

<script>
export default {
  name: 'FastTrackArchive',
}
</script>
